import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { CONSTANT } from "../../../shared/constants/constant-data";
import { toast } from "react-toastify";
import axiosInstance from "../../../axios/axios";
import { END_POINTS } from "../../../shared";
import Loading from "../../../components/loader";

const SsoInvite = () => {
  const { id, token } =  useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    //const id = searchParams.get("id");
    //const token = searchParams.get("token") || "";
    if (id && token) {
      setLoading(true);
      axiosInstance
        .get(`${END_POINTS.ACTIVATE_REGISTRATION}/${id}/${token}`)
        .then((response: any) => {
          if (response.data.status === 200 || response.status === 200) {
            toast.success(CONSTANT.SSO_REGISTRATION);
            navigate("/login");
          } else {
            showErrorMsg();
          }
        })
        .catch(() => {
          showErrorMsg();
          navigate("/login");
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      showErrorMsg();
      navigate("/login");
    }
  }, [navigate, id,token]);

  const showErrorMsg = () => {
    toast.error(CONSTANT.INVALID_RESET_TOKEN_MSG);
  };
  return <Loading show={loading} />;
};

export default SsoInvite;
